import { Injector } from '@angular/core';
import { InjectorService } from '../injector/injector.service';
import { EnvService } from 'src/app/shared/common/services/env.service';
import { CheckinHttpClient } from 'src/app/shared/services/http/http-client.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as i0 from "@angular/core";
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
        var injector = InjectorService.get();
        this.config = injector.get(ConfigService);
        var env = injector.get(EnvService);
        Object.assign(this, {
            http: injector.get(CheckinHttpClient),
            urlAnalytics: env.endpoint + "/v2/analytics"
        });
    }
    AnalyticsService.prototype.initCheckin = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'Init',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.closeCheckin = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'Finish',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.countryAgeSuccess = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'CountryAge_Success',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.selectDocumentSucces = function (documentType) {
        var stepsConfiguration = this.getStepsConfiguration();
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'SelectDocument_Success',
            eventLabel: stepsConfiguration + "/" + documentType
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.selectUploadType = function (photoOrUploadType) {
        var stepsConfiguration = this.getStepsConfiguration();
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'PhotoOrUpload_Success',
            eventLabel: stepsConfiguration + "/" + photoOrUploadType
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.uploadDocumentSucces = function (documentType, photoOrUploadType) {
        var stepsConfiguration = this.getStepsConfiguration();
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'DocumentPhoto_Success',
            eventLabel: stepsConfiguration + "/" + documentType + "/" + photoOrUploadType
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.selfiePhotoSuccess = function (documentType) {
        var stepsConfiguration = this.getStepsConfiguration();
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'SelfiePhoto_Success',
            eventLabel: stepsConfiguration + "/" + documentType
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.sendFormSuccess = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'Form_Success',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.addCardSuccess = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'AddCard_Success',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.signDocumentsSuccess = function () {
        var params = {
            eventCategory: 'Checkin_Process',
            eventAction: 'SignDocuments_Success',
            eventLabel: this.getStepsConfiguration()
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.openCheckin = function (project) {
        var params = {
            eventCategory: 'Checkin_Open',
            eventAction: 'Open',
            eventLabel: project
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.openDelegation = function () {
        var params = {
            eventCategory: 'Checkin_Delegation',
            eventAction: 'Init',
            eventLabel: ''
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.delegationSuccess = function () {
        var params = {
            eventCategory: 'Checkin_Delegation',
            eventAction: 'Finish',
            eventLabel: ''
        };
        this.sendEvent(params);
    };
    AnalyticsService.prototype.sendEvent = function (params) {
        params.customDimentions = {
            showProcessInfo: 'A'
        };
        var req = this.http.post(this.urlAnalytics + "/event", params).pipe(catchError(function (error) { return throwError(error || 'Server error'); })).subscribe(function () {
            req.unsubscribe();
        });
    };
    AnalyticsService.prototype.getStepsConfiguration = function () {
        var _a = [
            +this.config.checkin.config.isOcrActivated,
            1,
            +this.config.checkin.config.showTravelInfoOnWizard,
            +this.config.checkin.config.isCreditCardRequired,
            +Object.values(this.config.checkin.config.documentsId).some(function (val) { return val !== null; })
        ], step1 = _a[0], step2 = _a[1], step3 = _a[2], step4 = _a[3], step5 = _a[4];
        return "step1:" + step1 + ",step2:" + step2 + ",step3:" + step3 + ",step4:" + step4 + ",step5:" + step5;
    };
    AnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
    return AnalyticsService;
}());
export { AnalyticsService };
